import { IOptions } from '../../../../../interfaces/Rights';
import FilterOptionItem from './FilterOptionItem';
import { FilterColumnProps } from '../types';

const ALL_OPTION: IOptions = { id: -1, value: '__all__', label: 'Todos' };

type FilterOptionListProps = Omit<FilterColumnProps, 'icon'> & {
    className?: string;
    // Resalta con color las opciones seleccionadas (en mobile se desactiva)
    bgSelected?: boolean;
};

const FilterOptionList = ({ title, options, selectedValues, onSelect, visible, emptyMessage, noOptionsMessage = 'No hay valores disponibles', showArrow, onSelectAll, className = '', bgSelected }: FilterOptionListProps) => {
    const idPrefix = title.replace(/\s+/g, '-');
    const isAllSelected = options.length > 0 && options.every(option => selectedValues.includes(option.value));
    const showAllOption = visible && !!onSelectAll && options.length > 1;

    return (
        <ul className={`overflow-y-auto ${className}`}>
            {!visible && emptyMessage && (
                <li className='p-4 text-bsmall md:text-blarge text-system-light-40 h-full flex items-center justify-center'>{emptyMessage}</li>
            )}
            {visible && options.length === 0 && (
                <li className='p-4 text-bsmall md:text-blarge text-system-light-40 h-full flex items-center justify-center'>{noOptionsMessage}</li>
            )}
            {showAllOption && (
                <FilterOptionItem
                    option={ALL_OPTION}
                    idPrefix={idPrefix}
                    isSelected={isAllSelected}
                    index={0}
                    onSelect={() => onSelectAll?.(!isAllSelected)}
                    showArrow={false}
                    bgSelected={bgSelected}
                />
            )}
            {visible && options.map((option, index) => (
                <FilterOptionItem
                    key={`${option.id}-${option.value}`}
                    option={option}
                    idPrefix={idPrefix}
                    isSelected={selectedValues.includes(option.value)}
                    index={showAllOption ? index + 1 : index}
                    onSelect={onSelect}
                    showArrow={showArrow}
                    bgSelected={bgSelected}
                />
            ))}
        </ul>
    );
};

export default FilterOptionList;
